import React, { useEffect, useState } from 'react';
import api from '../api';

function AdminLogs() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    api.get('/api/admin/audit-logs')
      .then(res => setLogs(res.data))
      .catch(err => console.error('AdminLogs error:', err));
  }, []);

  return (
    <div>
      <h2>Audit Logs</h2>
      {logs.length === 0 ? (
        <p>No logs yet.</p>
      ) : (
        <div className="table-box">
          <table>
            <thead>
              <tr>
                <th>User</th>
                <th>Action</th>
                <th>Details</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {logs.map(log => (
                <tr key={log.id}>
                  <td>{log.User?.email}</td>
                  <td>{log.action}</td>
                  <td>{log.details}</td>
                  <td>{new Date(log.createdAt).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
export default AdminLogs;